<template>
    <div>
        <el-input
            v-if="mode === 'edit'"
            v-model="currentValue"
            min="0"
            max="100"
            :placeholder="placeholder"
            :data-bot="dataBot"
            @blur="formatAmount"
        >
            <template #append>%</template>
        </el-input>
        <p v-else>{{ currentValue }} %</p>
    </div>
</template>

<script>
export default {
    props: {
        mode: {
            type: String,
            default: '',
        },
        modelValue: {
            type: [Number, String],
            required: false,
            default: 0,
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
        dataBot: {
            type: String,
            required: false,
            default: '',
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            numberFormat: window.App.numformat,
        };
    },
    computed: {
        currentValue: {
            get() {
                return this.modelValue;
            },
            set(newValue) {
                this.$emit('update:modelValue', newValue);
            },
        },
    },
    created() {
        this.numberFormat = { ...window.App.numformat };
        this.numberFormat.precision = 0;

        this.currentValue = NumberFormat.formatToDisplay(this.modelValue, this.numberFormat);
    },
    methods: {
        formatAmount() {
            if (!this.currentValue) {
                this.currentValue = 0;
            }
            this.currentValue = parseInt(this.currentValue);
            if (this.currentValue > 100) {
                this.currentValue = 100;
            }
            this.currentValue = NumberFormat.formatToDisplay(this.currentValue, this.numberFormat);
        },
    },
};
</script>
